import React, { createContext, useContext } from 'react';

const VehicleContext = createContext(null);

export const useVehicleContext = () => {
  const ctx = useContext(VehicleContext);
  if (!ctx) throw new Error('useVehicleContext must be used within VehicleProvider');
  return ctx;
};

export default VehicleContext;